export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType[SubscriptionType["Benefits"] = 0] = "Benefits";
    SubscriptionType[SubscriptionType["EA"] = 1] = "EA";
    SubscriptionType[SubscriptionType["Free"] = 2] = "Free";
    SubscriptionType[SubscriptionType["Internal"] = 3] = "Internal";
    SubscriptionType[SubscriptionType["PAYG"] = 4] = "PAYG";
})(SubscriptionType || (SubscriptionType = {}));
